module.exports = __webpack_public_path__ + "static/img/smbj_jcjg_icon.png";